import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Items } from 'app/core/models/items';
import { TranslateService } from '@ngx-translate/core';
import { NotifMessageService } from 'app/core/services/notifmessage.service';
import { MetaWalletReportingService } from 'app/core/services/meta-wallet-reporting.service';
import { WalletsByPeriod } from 'app/core/models/walletsByPeriod';
import { BaseComponent } from 'app/base/base.component';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-wallets-evolution-reports',
  templateUrl: './wallets-evolution-reports.component.html',
  styleUrls: ['./wallets-evolution-reports.component.css']
})
export class WalletsEvolutionReportsComponent extends BaseComponent implements OnInit {


  walletsEvolutionReportForm: FormGroup;
  periodSub: Subscription;
  subscription: Subscription;

  isLoading: boolean;
  period: number = 12;
  periodItems: Array<number> = Array<number>(3, 6, 12);
  walletsEvolutionReport: Items<WalletsByPeriod>;
  fromDate: Date;
  reportData: number[];
  reportLabel: string[];
  reportTitle: string;

  criteria = {
    windowBegin: this.getFromDate(this.period),
    windowEnd: new Date()
  };

  displayedColumns = ['month', 'year','walletCount'];

  constructor(
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private notifService: NotifMessageService,
    private metaWalletReportingService: MetaWalletReportingService,
    router: Router) { super(router) }

  ngOnInit() {
    this.walletsEvolutionReportForm = this.formBuilder.group({
      period: new FormControl(this.period, Validators.required)
    });

    this.getNumberOfNewWalletByPeriod();

    this.periodSub = this.walletsEvolutionReportForm.get("period").valueChanges.subscribe(val => {
      if (this.walletsEvolutionReportForm.get("period").valid) {

        this.period = val;
        this.criteria.windowBegin = this.getFromDate(val);
        this.getNumberOfNewWalletByPeriod();
      }

    });
  }

  getNumberOfNewWalletByPeriod(): void {
    this.reportTitle = this.translate.instant("WALLETS_NUMBER_EVOLUTION");
    this.isLoading = true;
    this.metaWalletReportingService.getNumberOfNewWalletByPeriod(this.criteria).subscribe(
      items => {
        this.walletsEvolutionReport = items;
        this.reportLabel = items.map(items => this.getMonthName(items.month) + " " + items.year);
        this.reportData = items.map(items => items.walletCount);
        this.isLoading = false;
        if (items.empty) {
          this.notifService.notifyInfo('EMPTY_RESULT');
        }
      });
  }

  getMonthName(month: number): string {
    let monthName = this.monthMap.get(month);
    return this.translate.instant(monthName);
  }

  getFromDate(period: number): Date {
    this.fromDate = new Date();
    this.fromDate.setMonth(this.fromDate.getMonth() - period);
    return this.fromDate;
  }

  isActive(walletsEvolutiontatus): boolean {
    if (walletsEvolutiontatus == "ACTIVE")
      return true;
    return false;
  }

  date() {
    let frDateFormat = "dd MMM y";
    let usDateFormat = "MMM dd y";
    if (this.translate.currentLang == "fr_FR")
      return frDateFormat;
    else
      return usDateFormat;
  }

  locale() {
    if (this.translate.currentLang == "fr_FR")
      return "fr_FR";
    else
      return "en_US";
  }


  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.periodSub) {
      this.periodSub.unsubscribe();
    }
  }


}
